export default __webpack_public_path__ + "static/6-933555ca426e262d5189489d2e749191.jpg";